import { useFlags } from 'launchdarkly-react-client-sdk';

const LaunchDarklyWrapper = ({ render }) => {
  const flags = useFlags();

  return render(flags);
};

export default LaunchDarklyWrapper;
